module.exports = __webpack_public_path__ + "img/163-697672.png";